//
// Spacer
//

import classNames from 'classnames';
import PropTypes from 'prop-types';

const Spacer = function Spacer(props) {
  const {
    sz = 2,
    col,
  } = props;

  return (
    <div
      className={classNames(
        {
          [`min-w-${sz} w-${sz}`]: (!col),
          [`min-h-${sz} h-${sz}`]: col,
        },
      )}
    />
  );
};

Spacer.propTypes = {
  sz: PropTypes.number,
  col: PropTypes.bool,
};

export default Spacer;
